module.exports = __webpack_public_path__ + "img/loginChicken.fa507d8d.png";